import * as Sentry from '@sentry/vue';

import VALIDATORS from '@validators/all';

import fieldName, { combinedName } from '../javascripts/name';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

export default function printer(props, planter) {
  const {
    leaves,
    values,
    parents,
    errors,
    properties,
  } = planter;

  function identify(details, name) {
    let _name = name;

    if (/\[\d+\]\[*/.test(_name)) {
      Object.keys(details.object || {})
        .filter((i) => /_type_id$/.test(i))
        .some((typeID) => {
          let found;
          const finding = String(details.object[typeID]);

          found = _name.split('[').slice(0, -2);
          found = new RegExp(`^${found.join('\\[')}.*_type_id]$`);
          found = Object.keys(leaves.value).filter((i) => found.test(i) && leaves.value?.[i].validations.some((j) => j.type === 'constant'));
          found = found?.find((i) => String(values.value[i]) === finding)?.split('[');

          const index = found?.[found.length - 2].replace(']', '');

          if (index === String(parseInt(index, 10))) {
            _name = _name.split('[');

            _name[_name.length - 2] = found[found.length - 2];
            _name = _name.join('[');

            return true;
          }

          return false;
        });
    }

    return _name;
  }

  function first(current) {
    return Object
      .keys(leaves.value)
      .find((i) => true
        && i.includes(current)
        && !leaves.value[i].combine
        && !leaves.value[i].validations.some((j) => j.type === 'constant'))
      ?.split('[')
      ?.pop()
      ?.replace(']', '');
  }

  function iterable(details, current, key, name, field) {
    const detail = details[key] || [];
    const { error } = field;

    // banks-api

    if (field.opts?.validation) {
      return field.opts.validation;
    }

    // web

    if (!error) {
      return false;
    }

    if (leaves.value[name]) {
      return true;
    }

    // if (error === 'blank') {
    //   console.log('BLANK', name, parents.value[name]);
    // }

    return detail[detail.length - 1]?.error !== 'too_short';
  }

  function print(details, current, endpoint, initial = true) {
    /* eslint-disable no-console */

    if (initial) {
      console.groupCollapsed(`INVALIDATIONS: "${endpoint}" (${new Date().toISOString()})`);
    }

    Object
      .keys(details)
      .forEach((key) => {
        let _child;

        const next = fieldName(current, key);
        const name = identify(details, next);
        const detail = details[key]
          ?.find?.((field) => iterable(details, current, key, name, field));

        if (detail) {
          const validation = VALIDATORS[detail.error] || VALIDATORS.invalid;

          if (leaves.value[name]) {
            const message = validation.message(values.value[name], detail);

            console.log(
              `${name} → ${message}`,
            );

            if (properties.value[name].combined) {
              const combined = fieldName(
                parents.value[name],
                combinedName(props.combine[parents.value[name]]),
              );

              if (!errors.value[combined]) {
                errors.value[combined] = validation.message(values.value[combined], detail);
              }
            } else {
              errors.value[name] = message;
            }
          } else {
            console.log(
              `↓ (NOT FOUND) ${name}`,
              `\n• ${validation.message()} (${details[key].map((i) => i.error || 'nested').join(', ')})`,
            );

            _child = next;
          }
        } else if (details[key] && typeof details[key] === 'object') {
          print(details[key], next, endpoint, false);
        } else if (key === 'error') {
          _child = current;
        }

        if (_child) {
          const _first = first(_child);

          if (_first) {
            print({ [_first]: [{ error: 'blank' }] }, _child, endpoint, false);
          }
        }
      });

    if (initial) {
      console.groupCollapsed('FULL DETAILS (stringified)');
      console.log(JSON.stringify(details));
      console.groupEnd();
      console.groupEnd();

      if (SENTRY_DSN) {
        Sentry.captureException({
          title: 'INVALIDATIONS',
          banks: props.banks,
          endpoint,
          details,
        });
      }
    }
  }

  return {
    print,
  };
}
